import { acquireTokenSilent } from '../config/msalConfig';

export interface ClinicLocation {
  clinic_id: number;
  name: string;
  city: string;
  lat: number;
  lng: number;
  active: boolean;
  practice_location_id?: number | null;
  address?: string | null;
  updated_at?: string;
}

export class ClinicLocationService {
  private static baseUrl =
    (import.meta.env.VITE_FUNCTION_APP_URL || 'https://func-axis-referral-dev.azurewebsites.net') + '/api';

  private static async getToken(): Promise<string> {
    const tokenResult = await acquireTokenSilent();
    return tokenResult.accessToken;
  }

  static async listClinics(includeInactive = true): Promise<ClinicLocation[]> {
    const params = includeInactive ? '' : '?include_inactive=false';
    const response = await fetch(`${this.baseUrl}/rules/clinic-locations${params}`, {
      headers: { Authorization: `Bearer ${await this.getToken()}` },
    });
    if (!response.ok) throw new Error('Failed to load clinic locations');
    const data = await response.json();
    return data.clinics || [];
  }

  static async updateClinic(
    clinicId: number,
    updates: Partial<Pick<ClinicLocation, 'name' | 'city' | 'lat' | 'lng' | 'active' | 'address' | 'practice_location_id'>>,
  ): Promise<ClinicLocation> {
    const response = await fetch(`${this.baseUrl}/rules/clinic-locations/${clinicId}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${await this.getToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Failed to update clinic');
    return response.json();
  }
}
